import Chart from 'chart.js/auto';
import type { TimelineEntry } from '@/state/types.ts';

interface MoodChartController {
  root: HTMLElement;
  render: (entries: TimelineEntry[]) => void;
}

export function createMoodChart(): MoodChartController {
  const canvas = document.createElement('canvas');
  canvas.className = 'w-full h-64';

  let chart: Chart | null = null;

  const render = (entries: TimelineEntry[]) => {
    const labels = entries.map((e) => e.label);
    const data = entries.map((e) => e.mood);

    if (chart) {
      chart.data.labels = labels;
      chart.data.datasets[0].data = data;
      chart.update();
      return;
    }

    chart = new Chart(canvas, {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Mood',
            data,
            borderColor: '#2563EB',
            backgroundColor: 'rgba(37, 99, 235, 0.1)',
            tension: 0.3,
            fill: true,
            pointRadius: 4,
            pointBackgroundColor: '#1D4ED8',
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            min: 0,
            max: 10,
            ticks: { stepSize: 1 },
          },
        },
        plugins: {
          legend: { display: false },
        },
      },
    });
  };

  return { root: canvas, render };
}
